module.exports = __webpack_public_path__ + "img/hero-home.5ba3b58b.webp";